import { GbToBytes } from "../utils/genericUtils";

const subscriptionsMaxBytes = {
  0: GbToBytes(5), //5GB
  1: GbToBytes(250), //250GB
  2: GbToBytes(500), //500GB
  3: GbToBytes(1000), //1TB
};

export default subscriptionsMaxBytes;
